<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getBinLocations"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'bin-locations-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-4">Code</div>
        <div class="col-md-6">Description</div>
        <div class="col-md-2 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
      
        <div class="col-md-4 my-auto">
          <p class="m-0 font-weight-bold">{{ slotProps.item.code }}</p>
        </div>

        <div class="col-md-6 my-auto">
          <p class="m-0">{{ slotProps.item.description }}</p>
        </div>

        

        <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'bin-locations-show',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{
              name: 'bin-locations-edit',
              params: { id: slotProps.item.id },
            }"
            class="text-primary table-action-icon"
          >
            <i class="lni lni-pencil"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(slotProps.item.id)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-trash"></i>
          </span>
        </div>
      </template>
    </data-table>

      <b-modal    
      :hide-footer="true" 
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'bin-locations' })"
      :lazy="true"
      >
       <router-view
       @binLocationCreated="binLocationCreated()"
          @binLocationUpdated="binLocationUpdated()"
        ></router-view>       
    </b-modal>

  
  </div>
</template>

<script>
import binLocationRepo from "@/api/repos/binLocationRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "code", label: "Code Asc", order: "asc" },
      sortOptions: [
        { column: "code", label: "Code Asc", order: "asc" },
        { column: "code", label: "Code Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getBinLocations({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async deleteBinLocation(id) {
      this.isBusy = true;
      try {
        await binLocationRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete the action.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.deleteBinLocation(id) : false))
        .catch((error) => console.log(error));
    },
    async getBinLocations(e) {
      this.isLoad = true;
      try {
        let { data } = await binLocationRepo.binLocations(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.bin_locations.data;
        this.totalRows = data.bin_locations.total;
        this.page = data.bin_locations.current_page;
        this.fromRow = data.bin_locations.from;
        this.toRow = data.bin_locations.to;
        this.lastPage = data.bin_locations.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    binLocationCreated() {
      this.$bvToast.toast("Bin Location Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getBinLocations({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },

    binLocationUpdated() {
      this.$bvToast.toast("Bin Location Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getBinLocations({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
